module.exports = __webpack_public_path__ + "assets/cuddledogs.875a0772.svg";